var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncruit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 19.5012V3.33317C48.5 2.62593 48.2191 1.94765 47.719 1.44755C47.2189 0.947455 46.5406 0.666504 45.8333 0.666504H43.1667C37.8893 5.94384 27.9747 8.8985 21.8333 10.3012V39.0318C27.9747 40.4345 37.8893 43.3892 43.1667 48.6665H45.8333C46.5406 48.6665 47.2189 48.3856 47.719 47.8855C48.2191 47.3854 48.5 46.7071 48.5 45.9998V29.8318C49.646 29.5372 50.6615 28.8698 51.3866 27.9346C52.1117 26.9995 52.5053 25.8498 52.5053 24.6665C52.5053 23.4832 52.1117 22.3335 51.3866 21.3984C50.6615 20.4633 49.646 19.7958 48.5 19.5012ZM5.83333 11.3332C4.41885 11.3332 3.06229 11.8951 2.0621 12.8953C1.0619 13.8955 0.5 15.252 0.5 16.6665V32.6665C0.5 34.081 1.0619 35.4375 2.0621 36.4377C3.06229 37.4379 4.41885 37.9998 5.83333 37.9998H8.5L11.1667 51.3332H16.5V11.3332H5.83333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncruit);
export default __webpack_public_path__ + "resume/static/media/incruit.6028a9b1f5bc8ad5376c13ff593bc0be.svg";
export { ForwardRef as ReactComponent };